import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./leadpage.module.css";
import { Row, Col, Spinner } from "react-bootstrap";

// Context & Permissions
import { useGlobal } from "../../GlobalContext";
import { canEdit, canDelete } from "../common/permissionUtils";

// SVG Images
import User from "../../assets/svg/user.svg";
import Mail from "../../assets/svg/mail.svg";
import Phone from "../../assets/svg/phone.svg";
import Building from "../../assets/svg/building.svg";
import IT from "../../assets/svg/it.svg";
import Location from "../../assets/svg/location.svg";
import Clock from "../../assets/svg/notesclock.svg";
import Notesprofile from "../../assets/svg/notesprofile.svg";
import Download from "../../assets/svg/download-icon.svg";
import { Toast, ToastContainer } from "react-bootstrap";

// PNG Images
import Profile from "../../assets/png/profile.png";
import {
  getLeadDataApi,
  getNotesApi,
  addNoteApi,
  getAttachmentsApi,
  addAttachmentApi,
  getActivityApi,
  getHistoryApi,
  updateWebsiteInfoApi,
  getLeadStatusApi,
  updateLeadStatusApi,
  checkLeadConversionApi,
  getLoadLinkedInProfilesApi,
  getLinkedInProfilesApi,
  updateLinkedInProfilesApi,
  updateWebScrapingApi,
  getLeadContactsApi,
  getLeadAiSummaryApi,
} from "./leads-api";
import LeadConversionModal from "./lead-conversion-modal";
import {
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFileImage,
  FaFileArchive,
  FaFileAlt,
  FaFile,
  FaPlus,
} from "react-icons/fa";
import { ReactComponent as WebsiteIC } from "../../assets/svg/website-icon.svg";
import { ReactComponent as WebsiteSearchIC } from "../../assets/svg/website-search-icon.svg";
import { ReactComponent as WebsiteEditIC } from "../../assets/svg/website-edit-icon.svg";

import { ReactComponent as InstaIc } from "../../assets/svg/insta_ic.svg";
import { ReactComponent as XIC } from "../../assets/svg/x-ic.svg";
import { ReactComponent as LinIC } from "../../assets/svg/linkden_ic.svg";
import { ReactComponent as YoutIC } from "../../assets/svg/youtub_ic.svg";
import { ReactComponent as FasIC } from "../../assets/svg/fas_ic.svg";
import { ReactComponent as ClockIc } from "../../assets/svg/clock_icsa.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/downArrowIc.svg";
import { ReactComponent as DownNewArrowIc } from "../../assets/svg/downArow_icsa.svg";
import { ReactComponent as NoteHist } from "../../assets/svg/note_hist.svg";
import { ReactComponent as LeadHist } from "../../assets/svg/lead_hist.svg";
import { ReactComponent as AttachHist } from "../../assets/svg/attach_hist.svg";
import { ReactComponent as StatusHist } from "../../assets/svg/status_hist.svg";
import { ReactComponent as QuotHist } from "../../assets/svg/quot_hist.svg";
import { ReactComponent as EditHist } from "../../assets/svg/edit_hist.svg";
import { ReactComponent as ContactHist } from "../../assets/svg/contact_hist.svg";
import { ReactComponent as EmailHist } from "../../assets/svg/email_hist.svg";
import { ReactComponent as CallHist } from "../../assets/svg/call_hist.svg";
import { ReactComponent as ThreeDot } from "../../assets/svg/three_dot_ic.svg";
import { ReactComponent as Delete } from "../../assets/svg/delete-po.svg";
import { ReactComponent as ContactDeleteIcon } from "../../assets/svg/delete.svg";
import CreateContactModal from "../common/CreateContactModal.jsx";
import CreateCallModal from "../common/CreateCallModal.jsx";
import WebsiteDetailsWidget from "../common/webscraping";
import WebSiteSearchModal from "../common/website-search-model";
import ComposeLeadModal from "./lead-email-module";
import WebSiteEditModal from "../common/website-edit-model";
import WebSiteDeleteModal from "../common/delete-website-modal";
import closeIcon from "../../assets/svg/cancel.svg";
import rightArrowIcon from "../../assets/svg/arrow-right.svg";
import linkedInIcon from "../../assets/svg/linkedin.svg";
import refreshIcon from "../../assets/svg/refresh_ic.svg";
import DeleteModal from "../common/delete-modal";
import AiSummaryCard from "../common/ai-summary-card.js";
import {
  sanitizeInput,
  validateFileType,
  validateFileSize,
  sanitizeFileName,
  downloadBlobFile,
} from "../common/security-utils.js";

const LinkedInDeleteConfirmModal = ({ onConfirm, onCancel }) => {
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "40px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 1)",
      width: "436px",
      minHeight: "228px",
      textAlign: "center",
    },
  };

  return (
    <div style={modalStyle.overlay} backdrop="static">
      <div style={modalStyle.modal}>
        <div style={{ color: "#ffffff" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{ fontSize: "20px", fontWeight: "700", color: "#1E1E1E" }}
            >
              Remove LinkedIn Profile
            </div>
            <div
              style={{
                marginTop: "8px",
                fontSize: "16px",
                fontWeight: "400",
                color: "#1E1E1E",
              }}
            >
              You won't be able to access this profile after removing. Are you
              sure you want to remove?
            </div>

            <div
              style={{
                flex: 12,
                marginTop: "24px",
                display: "flex",
                flexDirection: "row",
                alignItems: "start",
                justifyContent: "center",
                gap: "16px",
              }}
            >
              <div
                onClick={onCancel}
                style={{
                  cursor: "pointer",
                  width: "158px",
                  height: "44px",
                  borderRadius: "8px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid #E5E5E5",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#1E1E1E",
                  }}
                >
                  Cancel
                </div>
              </div>
              <div
                onClick={onConfirm}
                style={{
                  cursor: "pointer",
                  width: "158px",
                  height: "44px",
                  borderRadius: "8px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#FF4444",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#FFFFFF",
                  }}
                >
                  Remove
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const LeadDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  // 🔒 Permissions
  const { rolePermissionList } = useGlobal();
  const hasEditPermission = canEdit(rolePermissionList, "Leads");
  const hasDeletePermission = canDelete(rolePermissionList, "Leads");
  const historyIcons = {
    note: <NoteHist />,
    lead: <LeadHist />,
    attachment: <AttachHist />,
    status: <StatusHist />,
    quotation: <QuotHist />,
    edit: <EditHist />,
    contact: <ContactHist />,
    email: <EmailHist />,
    call: <CallHist />,
  };

  const [emailId, setEmailID] = useState(null);
  const [showWebSiteModal, openWebsiteModal] = useState(false);
  const [showWebSiteEditModal, openWebsiteEditModal] = useState(false);
  const [activeTab, setActiveTab] = useState("Overview");
  const [isLoading, setIsLoading] = useState(false);
  const [tabLoading, setTabLoading] = useState({});
  const [error, setError] = useState(null);
  const [websiteUrl, setWebSite] = useState("");
  const [overviewData, setOverviewData] = useState({});
  const [notes, setNotes] = useState({ notes: [] });
  const [newNote, setNewNote] = useState("");
  const [attachments, setAttach] = useState({ attachments: [] });
  const [activitiesList, setActivityList] = useState([]);
  const [histories, setHistory] = useState({ notes: [] });
  const [validationError, setValidationError] = useState("");
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [linkedInProfiles, setLinkedInProfiles] = useState([]);
  const [loadedLinkedInProfiles, setLoadedLinkedInProfiles] = useState([]);
  const [showLinkedInDeleteModal, setShowLinkedInDeleteModal] = useState(false);
  const [linkedInProfileToDelete, setLinkedInProfileToDelete] = useState(null);
  const [leadContactList, setLeadContactList] = useState([]);

  const setLoadingForTab = (tab, value) => {
    setTabLoading((prev) => ({ ...prev, [tab]: value }));
  };

  const apiUrl = process.env.REACT_APP_API_URL;
  const extensionIconMap = {
    pdf: <FaFilePdf color="red" />,
    doc: <FaFileWord color="blue" />,
    docx: <FaFileWord color="blue" />,
    xls: <FaFileExcel color="green" />,
    xlsx: <FaFileExcel color="green" />,
    csv: <FaFileExcel color="green" />,
    jpg: <FaFileImage color="blue" />,
    jpeg: <FaFileImage color="blue" />,
    png: <FaFileImage color="blue" />,
    gif: <FaFileImage color="purple" />,
    webp: <FaFileImage color="blue" />,
    bmp: <FaFileImage color="blue" />,
    svg: <FaFileImage color="blue" />,
    zip: <FaFileArchive color="orange" />,
    rar: <FaFileArchive color="orange" />,
    txt: <FaFileAlt color="gray" />,
    default: <FaFile color="blue" />,
  };
  const [showEmail, setEmailShow] = useState(false);
  const [statusOpen, setStatusOpen] = useState(false);
  const [leadStatus, setStatus] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [isStatusUpdating, setIsStatusUpdating] = useState(false);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const notify = (msg, isSuccess = true) => {
    setSnackbarMessage(msg);
    setSnackbarStatus(isSuccess);
    handleSnackbarShow();
  };

  // Create Contact popup (shared component)
  const [showCreateContact, setShowCreateContact] = useState(false);

  // Create Call popup (shared component)
  const [showCreateCall, setShowCreateCall] = useState(false);

  // Lead Conversion Confirmation Modal
  const [isConvertModalOpen, setIsConvertModalOpen] = useState(false);
  const [conversionInfo, setConversionInfo] = useState(null);
  const [isConverting, setIsConverting] = useState(false);

  const handleConfirmConversion = async (payload) => {
    setIsConverting(true);
    try {
      const response = await updateLeadStatusApi(payload, id);
      if (
        response?.success ||
        response?.data?.success ||
        response?.status === "success" ||
        response?.message?.includes("success") ||
        response
      ) {
        setStatus("Convert Account");
        setSnackbarMessage("Lead converted to Account successfully");
        setSnackbarStatus(true);
        handleSnackbarShow();
        setIsConvertModalOpen(false);
        setRefresh((prev) => !prev);
      } else {
        setSnackbarMessage(response?.message || "Failed to convert lead");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error converting lead:", err);
      setSnackbarMessage(
        err?.response?.data?.message || err?.message || "Error converting lead"
      );
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsConverting(false);
    }
  };

  // Delete Contact
  const [deleteContactId, setDeleteContactId] = useState(null);
  const [isOpenDeleteContact, setIsOpenDeleteContact] = useState(false);

  const handleDeleteContact = (contactId) => {
    if (!hasDeletePermission) {
      notify("You don't have permission to delete contacts", false);
      return;
    }
    setDeleteContactId(contactId);
    setIsOpenDeleteContact(true);
  };

  const cancelDeleteContact = () => {
    setIsOpenDeleteContact(false);
    setDeleteContactId(null);
  };

  const onSuccessDeleteContact = (response) => {
    setIsOpenDeleteContact(false);
    setDeleteContactId(null);
    notify(
      response?.message ||
        (response?.success
          ? response?.unmapped
            ? "Contact unmapped from lead successfully"
            : "Contact deleted successfully"
          : "Failed to delete contact"),
      response?.success
    );
    if (response?.success) fetchContacts();
  };

  const onSuccessDelete = (response) => {
    setIsOpenDelete(false);
    if (response.success === true) {
      setRefresh((prev) => !prev);
    }
  };

  const cancelDelete = () => {
    setIsOpenDelete(false);
  };

  useEffect(() => {
    if (emailId != null) {
      setEmailShow(true);
    }
  }, [emailId]);
  function getIconForExtension(filename) {
    const ext = filename.split(".").pop().toLowerCase();
    return extensionIconMap[ext] || extensionIconMap["default"];
  }

  const normalizeKey = (key = "") => {
    return key
      .replace(".com", "")
      .replace("www.", "")
      .split(".")[0]
      .toLowerCase();
  };

  const socialIcons = useMemo(
    () => ({
      linkedin: <LinIC />,
      facebook: <FasIC />,
      x: <XIC />,
      twitter: <XIC />,
      instagram: <InstaIc />,
      youtube: <YoutIC />,
    }),
    [],
  );

  const extractHandle = (url = "") => {
    if (!url) return "";

    try {
      let clean = url.replace(/https?:\/\/(www\.)?/i, "").replace(/\/$/, "");

      if (clean.includes("linkedin.com")) {
        const parts = clean.split("/");
        return parts[2] || "";
      }

      return clean.split("/")[1]?.replace("@", "") || clean;
    } catch {
      return "";
    }
  };

  const createSocialLinks = useCallback(
    (socialLinksArray = []) => {
      return socialLinksArray.map((item) => {
        const normalized = normalizeKey(item.name);

        return {
          name: "@" + extractHandle(item.link),
          icon: socialIcons[normalized] || null,
          url: item.link,
        };
      });
    },
    [socialIcons],
  );

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setLoadingForTab("Overview", true);
      setError(null);
      try {
        const data = await getLeadDataApi(id);

        setOverviewData(data.lead ?? {});
        setWebSite(data.lead.website ?? "");
        setStatus(data.lead.lead_status);

        setSocialLinks(createSocialLinks(data.lead.social_links ?? {}));
        setWebScrapDetials(data.lead.scrapping_details ?? {});
        setServicesList(data.lead.services ?? []);
        setIndustriesList(data.lead.industries ?? []);
        setProductsList(data.lead.products ?? []);
        setTeamsList(data.lead.teams ?? []);
        setAboutList(data.lead.abouts ?? []);
        setParnterList(data.lead.partners ?? []);
        setClientList(data.lead.clients ?? []);
        setPeopleList(data.lead.people ?? []);
        setCareersList(data.lead.careers ?? {});
        setPageDetails(data.lead.total_pages ?? 0);
        setPageLinList(data.lead.pages ?? []);
        const statusData = await getLeadStatusApi();
        setStatusOptions(statusData.suggestionlist);
        // Data fetched successfully
      } catch (error) {
        setError(error.message);
        // Error logged internally
      } finally {
        setIsLoading(false);
        setLoadingForTab("Overview", false);
      }
    };
    fetchData();
  }, [refresh, id, createSocialLinks]);

  const [skip, setSkip] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const scrollRef = useRef(null);

  const isLoadingRef = useRef(isLoading);
  const hasMoreRef = useRef(hasMore);
  const skipRef = useRef(skip);

  useEffect(() => {
    isLoadingRef.current = isLoading;
  }, [isLoading]);
  useEffect(() => {
    hasMoreRef.current = hasMore;
  }, [hasMore]);
  useEffect(() => {
    skipRef.current = skip;
  }, [skip]);

  const LIMIT = 10;

  const fetchNotes = useCallback(async () => {
    if (isLoadingRef.current || !hasMoreRef.current) return;
    setIsLoading(true);
    setError(null);
    const currentSkip = skipRef.current;
    try {
      const data = await getNotesApi(`?limit=${LIMIT}&skip=${currentSkip}`, id);
      const newNotes = data?.notes ?? [];
      setNotes((prev) => ({ notes: [...prev.notes, ...newNotes] }));
      setSkip((prev) => prev + LIMIT);
      setHasMore(newNotes.length === LIMIT);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  const fetchAttachmentList = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    setAttach({ attachments: [] });
    setSkip(0);
    try {
      const data = await getAttachmentsApi(``, id);
      const newAttach = data?.attachments ?? [];
      setAttach((prev) => ({
        attachments: [...prev.attachments, ...newAttach],
      }));
      setSkip((prev) => prev + LIMIT);
      setHasMore(newAttach.length === LIMIT);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  const fetchAttach = useCallback(async () => {
    if (isLoadingRef.current || !hasMoreRef.current) return;
    await fetchAttachmentList();
  }, [fetchAttachmentList]);
  const fetchActivity = useCallback(async () => {
    if (isLoadingRef.current || !hasMoreRef.current) return;
    setIsLoading(true);
    setError(null);
    const currentSkip = skipRef.current;
    try {
      const data = await getActivityApi(
        `?limit=${LIMIT}&skip=${currentSkip}`,
        id,
      );
      const newActivity = data?.activities ?? [];
      setActivityList(newActivity);
      setSkip((prev) => prev + LIMIT);
      setHasMore(newActivity.length === LIMIT);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  const fetchHistory = useCallback(async () => {
    if (isLoadingRef.current || !hasMoreRef.current) return;
    setIsLoading(true);
    setError(null);
    const currentSkip = skipRef.current;
    try {
      const data = await getHistoryApi(
        `?limit=${LIMIT}&skip=${currentSkip}`,
        id,
      );
      const newHistory = data?.histories ?? [];
      setHistory((prev) => ({ histories: [...prev.histories, ...newHistory] }));
      setSkip((prev) => prev + LIMIT);
      setHasMore(newHistory.length === LIMIT);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  const fetchContacts = useCallback(async () => {
    try {
      const result = await getLeadContactsApi(id);
      setLeadContactList(result.data?.contacts ?? []);
    } catch (error) {
    } finally {
    }
  }, [id]);

  useEffect(() => {
    if (activeTab === "Notes") {
      setNotes({ notes: [] });
      setSkip(0);
      setHasMore(true);
    }
    if (activeTab === "Attachments") {
      setAttach({ attachments: [] });
      setSkip(0);
      setHasMore(true);
    }
    if (activeTab === "Activities") {
      setSkip(0);
      setHasMore(true);
    }
    if (activeTab === "History") {
      setHistory({ histories: [] });
      setSkip(0);
      setHasMore(true);
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "Notes" && skip === 0) {
      setLoadingForTab("Notes", true);
      fetchNotes().finally(() => setLoadingForTab("Notes", false));
    }
    if (activeTab === "Attachments" && skip === 0) {
      setLoadingForTab("Attachments", true);
      fetchAttach().finally(() => setLoadingForTab("Attachments", false));
    }
    if (activeTab === "Activities" && skip === 0) {
      setLoadingForTab("Activities", true);
      fetchActivity().finally(() => setLoadingForTab("Activities", false));
    }
    if (activeTab === "History" && skip === 0) {
      setLoadingForTab("History", true);
      fetchHistory().finally(() => setLoadingForTab("History", false));
    }
    if (activeTab === "Contact") {
      setLoadingForTab("Contact", true);
      fetchContacts().finally(() => setLoadingForTab("Contact", false));
    }
  }, [
    activeTab,
    fetchNotes,
    fetchAttach,
    fetchActivity,
    fetchHistory,
    fetchContacts,
    skip,
  ]);

  useEffect(() => {
    const scrollableTabs = ["Notes", "Attachments", "Activities", "History"];
    if (!scrollableTabs.includes(activeTab)) return;
    const container = scrollRef.current;
    if (!container) return;
    const handleScroll = () => {
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 50
      ) {
        handleTabFetch();
      }
    };
    const handleTabFetch = () => {
      if (activeTab === "Notes") {
        fetchNotes();
      } else if (activeTab === "Attachments") {
        fetchAttach();
      } else if (activeTab === "Activities") {
        fetchActivity();
      } else if (activeTab === "History") {
        fetchHistory();
      }
    };
    container.addEventListener("scroll", handleScroll);
    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [activeTab, fetchNotes, fetchAttach, fetchActivity, fetchHistory]);

  const handleAddNote = async () => {
    setValidationError("");

    // Sanitize and validate input
    const sanitizedNote = sanitizeInput(newNote);
    if (!sanitizedNote) {
      setValidationError("The note field is required.");
      return;
    }

    // Validate note length
    if (sanitizedNote.length < 3) {
      setValidationError("Note must be at least 3 characters long.");
      return;
    }

    if (sanitizedNote.length > 5000) {
      setValidationError("Note must not exceed 5000 characters.");
      return;
    }

    setLoadingForTab("Notes Add", true);
    try {
      const response = await addNoteApi({ note: sanitizedNote }, id);
      if (response?.success) {
        setNotes((prevNotes) => ({
          notes: [
            ...prevNotes.notes,
            { note: sanitizedNote, date: "Just now", first_name: "You" },
          ],
        }));
        setNewNote("");
      } else {
        const errorMsg = response?.error?.note?.[0] || "An error occurred.";
        setValidationError(sanitizeInput(errorMsg));
      }
    } catch (error) {
      // Don't expose internal error details to user
      setValidationError("Failed to add note. Please try again.");
    } finally {
      setLoadingForTab("Notes Add", false);
    }
  };

  const fileInputRef = useRef(null);
  const handleAddAttachment = () => {
    setValidationError("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (e) => {
    setValidationError("");
    const file = e.target.files?.[0];
    if (!file) return;

    // Define allowed file types (including images and standard office documents)
    const allowedTypes = [
      "image/*",
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/bmp",
      "image/webp",
      "image/svg+xml",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
      "text/plain",
    ];

    const allowedExtensions = [
      "jpg", "jpeg", "png", "gif", "bmp", "webp", "svg",
      "pdf", "doc", "docx", "xls", "xlsx", "csv", "txt"
    ];
    const ext = file.name ? file.name.split(".").pop().toLowerCase() : "";
    const isAllowedType = validateFileType(file, allowedTypes) || allowedExtensions.includes(ext);

    // Validate file type
    if (!isAllowedType) {
      setValidationError(
        "Invalid file type. Only images, Excel, Word, and PDF files are allowed.",
      );
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    // Validate file size (10MB max)
    if (!validateFileSize(file, 10)) {
      setValidationError("File size must not exceed 10MB.");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    // Validate and sanitize filename
    const sanitizedFileName = sanitizeFileName(file.name);
    if (!sanitizedFileName) {
      setValidationError("Invalid file name.");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }
    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Validate base64 result
          const result = reader.result;
          if (typeof result === "string" && result.length > 0) {
            resolve(result);
          } else {
            reject(new Error("Invalid file encoding"));
          }
        };
        reader.onerror = () => reject(new Error("File reading failed"));
      });
    try {
      setLoadingForTab("Attachments Add", true);
      const base64 = await toBase64(file);

      // Additional validation on base64 string
      if (!base64 || typeof base64 !== "string" || base64.length === 0) {
        throw new Error("File encoding failed");
      }

      const payload = {
        base64,
        file_name: sanitizedFileName || file.name,
      };
      const response = await addAttachmentApi(payload, id);
      if (response?.success) {
        fetchAttachmentList();
        // Clear file input for security
        if (fileInputRef.current) fileInputRef.current.value = "";
      } else {
        const errorMsg =
          response?.error?.attachment?.[0] || "Failed to upload file.";
        setValidationError(sanitizeInput(errorMsg));
      }
    } catch (error) {
      // Don't expose internal error details
      setValidationError("Failed to upload file. Please try again.");
      // Clear file input on error
      if (fileInputRef.current) fileInputRef.current.value = "";
    } finally {
      setLoadingForTab("Attachments Add", false);
    }
  };

  const [filter, setFilter] = useState("All");

  const filters = [];

  const [open, setOpen] = useState(false);
  const [openThreeDot, setOpenThreeDot] = useState(false);
  const dropdownRef = useRef(null);
  const dropdownNewRef = useRef(null);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
        setStatusOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownNewRef.current &&
        !dropdownNewRef.current.contains(event.target)
      ) {
        setStatusOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const historyList = [
    {
      time: "10:41 AM",
      type: "note",
      title: "Note added - John Doe is interested in a product/service.",
      description:
        "He mentioned a specific feature of interest. He is currently evaluating a few options.",
      by: "Nandhu P",
      date: "May 23, 2025",
    },
    {
      time: "10:40 AM",
      type: "call",
      title: "Call added - Call scheduled with Carissa Kidman (sample data)",
      by: "Nandhu P",
      date: "May 23, 2025",
    },
    {
      time: "10:40 AM",
      type: "email",
      title: "Email Sent - Discussed points on call.",
      by: "Nandhu P",
      date: "May 23, 2025",
    },
    {
      time: "10:40 AM",
      type: "contact",
      title: "New contact created - Joseph Fernendas",
      by: "Nandhu P",
      date: "May 23, 2025",
    },
    {
      time: "10:40 AM",
      type: "edit",
      title: "Mobile number edited",
      description: "+9876543210 → +9876543210",
      by: "Nandhu P",
      date: "May 23, 2025",
    },
    {
      time: "10:40 AM",
      type: "quotation",
      title: "New quotation created - #QUO9834573498",
      by: "Nandhu P",
      date: "May 23, 2025",
    },
    {
      time: "10:40 AM",
      type: "note",
      title: "Notes added - John Doe is interested in a product/service.",
      description:
        "He mentioned a specific feature of interest. He is currently evaluating a few options.",
      by: "Nandhu P",
      date: "May 23, 2025",
    },
    {
      time: "10:40 AM",
      type: "status",
      title: "Status updated",
      description: "New → Contacted",
      by: "Nandhu P",
      date: "May 23, 2025",
    },
    {
      time: "10:38 AM",
      type: "attachment",
      title: "Attachment added - paper-airplane.png",
      by: "Nandhu P",
      date: "May 23, 2025",
    },
    {
      time: "10:40 AM",
      type: "lead",
      title: "Lead created",
      description: "New → Contacted",
      by: "Nandhu P",
      date: "May 23, 2025",
    },
  ];
  const activityIcons = {
    note: "📝",
    call: "📞",
    email: "✉️",
    contact: "👤",
    edit: "✏️",
    quotation: "📄",
    attachment: "📎",
    status: "🔄",
    lead: "🚀",
  };
  const [statusOptions, setStatusOptions] = useState([]);

  const getCleanType = (type) => {
    if (!type) return "";
    return type.trim().toLowerCase().split(" ")[0];
  };

  const [webScrapDetials, setWebScrapDetials] = useState({});
  const [serviceList, setServicesList] = useState([]);
  const [industriesList, setIndustriesList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [teamList, setTeamsList] = useState([]);
  const [aboutList, setAboutList] = useState([]);
  const [partnerList, setParnterList] = useState([]);
  const [payLinkDetails, setPageDetails] = useState({});
  const [payLinkList, setPageLinList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [peopleList, setPeopleList] = useState([]);
  const [careersList, setCareersList] = useState({});

  const sections = [
    { label: "Details", value: webScrapDetials },
    { label: "Services", value: serviceList },
    { label: "Industries", value: industriesList },
    { label: "Products", value: productsList },
    { label: "About", value: aboutList },
    { label: "Teams", value: teamList },
    { label: "Partners", value: partnerList },
    { label: "Pages Link", value: payLinkList },
    { label: "Clients", value: clientList },
    { label: "People", value: peopleList },
    { label: "Careers", value: careersList },
  ];

  const handleWebScrapSubmit = async (url, webScrapDetails) => {
    let response = await updateWebsiteInfoApi({ website: url }, id);
    if (response.success === true) {
      updateWebScraping(webScrapDetails);
    }
    setRefresh((prev) => !prev);
  };

  const updateWebScraping = async (webScrapDetails) => {
    try {
      let response = await updateWebScrapingApi(webScrapDetails, id);
      if (response.status === 200 && response.data.success === true) {
        setRefresh((prev) => !prev);
      }
    } catch (err) {
      // Error handled internally
    } finally {
    }
  };
  const handleWebsiteDelete = () => {
    // Website delete handler
    setIsOpenDelete(true);
  };

  const [socialLinks, setSocialLinks] = useState([]);

  const tabContent = {
    Overview: (
      <div>
        <AiSummaryCard
          api={getLeadAiSummaryApi}
          module="lead"
          id={id}
          initial={overviewData}
          hint="Score this lead on its scraped website data, LinkedIn profiles, notes, activities and calls — with a suggested next action."
        />

        {overviewData.website === "" && (
          <div
            style={{
              fontWeight: 600,
              fontSize: 16,
              marginBottom: 8,
              backgroundColor: "#FAFAFA",
              height: "273px",
              padding: "74px",
              textAlign: "center",
              borderRadius: "16px",
            }}
          >
            <div
              style={{
                color: "#172B4D",
                fontSize: "20px",
                fontWeight: "600",
                marginBottom: "16px",
              }}
            >
              Add website link
            </div>
            <div
              style={{
                color: "#8790A1",
                fontWeight: "400",
                fontSize: "14px",
                marginBottom: "20px",
                width: "434px",
                margin: "0 auto",
              }}
            >
              Provide the website link to gather complete company information
              for lead assessment.
            </div>
            <div
              style={{
                backgroundColor: "#3D4AF5",
                borderRadius: "100px",
                padding: "10px 28px",
                color: "white",
                width: "112px",
                margin: "0 auto",
                fontSize: "14px",
                cursor: "pointer",
              }}
              onClick={() => openWebsiteEditModal(true)}
            >
              {" "}
              Add link
            </div>
          </div>
        )}

        {overviewData.website && Object.keys(webScrapDetials).length <= 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between", // 👈 Push right icons to end
              alignItems: "center",
              fontWeight: 600,
              fontSize: 16,
              color: "#172B4D",
              marginBottom: 8,
              padding: "12px",
            }}
          >
            {/* LEFT SIDE */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                borderRadius: "24px",
                border: "1px solid #EBEBEB",
                width: "95%",
                padding: "10px",
              }}
            >
              <WebsiteIC />
              <div
                style={{
                  color: "#3D4AF5",
                  fontSize: "16px",
                  fontWeight: "500",
                  marginLeft: "10px",
                  width: "90%",
                }}
              >
                {overviewData.website}
              </div>
              <div style={{ display: "flex", gap: "12px", alignItems: "end" }}>
                <WebsiteEditIC
                  onClick={() => openWebsiteEditModal(true)}
                  style={{ cursor: "pointer" }}
                />
                <WebsiteSearchIC
                  onClick={() => {
                    openWebsiteModal(true);
                    setWebSite(overviewData.website);
                  }}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>

            {/* RIGHT SIDE ICONS */}

            <Delete
              style={{ cursor: "pointer" }}
              onClick={async () => {
                setIsOpenDelete(true);
              }}
            />
          </div>
        )}

        {overviewData.website && Object.keys(webScrapDetials).length > 0 && (
          <WebsiteDetailsWidget
            webScrapDetails={webScrapDetials}
            sections={sections}
            socialLinks={socialLinks}
            serviceList={serviceList}
            industriesList={industriesList}
            productsList={productsList}
            teamList={teamList}
            partnerList={partnerList}
            payLinkDetails={payLinkDetails}
            payLinkList={payLinkList}
            aboutList={aboutList}
            clientList={clientList}
            peopleList={peopleList}
            careersList={careersList}
            teamGrid={"2"}
            sourcePage="view"
            onWebsiteSubmit={handleWebScrapSubmit}
            onWebsiteDelete={handleWebsiteDelete}
          />
        )}
      </div>
    ),
    LinkedIn: (
      <div
        style={{ background: "#FFFFFF", borderRadius: "16px", padding: "0" }}
      >
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "600",
            color: "#172B4D",
            marginBottom: "20px",
          }}
        >
          LinkedIn Profile
        </h3>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "16px",
            marginBottom: "32px",
          }}
        >
          {linkedInProfiles.map((profile) => (
            <div
              key={profile.id}
              style={{
                backgroundColor: "#F8F8F8",
                borderRadius: "16px",
                padding: "16px",
                position: "relative",
              }}
            >
              {/* Close button */}
              <button
                onClick={() => updateLinkedInProfiles(profile.id, null)}
                style={{
                  position: "absolute",
                  top: "16px",
                  right: "16px",
                  background: "#FFFFFF",
                  border: "none",
                  cursor: "pointer",
                  color: "#FF6B6B",
                  fontSize: "20px",
                  fontWeight: "400",
                  padding: "0",
                  width: "20px",
                  height: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: "1",
                  borderRadius: "100%",
                }}
              >
                <img src={closeIcon} alt="Close" />
              </button>

              {/* Profile Name */}
              <h4
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#172B4D",
                  marginBottom: "4px",
                  marginTop: "0",
                  paddingRight: "24px",
                }}
              >
                {profile.name}
              </h4>

              {/* Profile Title */}
              <p
                style={{
                  fontSize: "13px",
                  fontWeight: "400",
                  color: "#5B5AFF",
                  marginBottom: "8px",
                  margin: "0 0 8px 0",
                  lineHeight: "1.4",
                }}
              >
                {profile.title}
              </p>
              <div
                className="mb-2"
                style={{
                  width: "100%",
                  height: "1px",
                  border: "1px solid #E0E3E5",
                }}
              ></div>
              {/* Profile Description */}
              <p
                style={{
                  fontSize: "13px",
                  fontWeight: "400",
                  color: "#6B7280",
                  marginBottom: "16px",
                  lineHeight: "1.6",
                  margin: "0 0 16px 0",
                }}
              >
                {profile.description}
              </p>

              {/* View Profile Link */}
              <a
                href={profile.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-flex",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#172B4D",
                  textDecoration: "none",
                  backgroundColor: "#FFFFFF",
                  padding: "8px 12px",
                  borderRadius: "100px",
                }}
              >
                <img src={linkedInIcon} alt="LinkedIn" />
                View profile
                <img src={rightArrowIcon} alt="Arrow Right" />
              </a>
            </div>
          ))}
        </div>

        {/* Loaded Profiles (stacked cards) */}
        <div
          style={{
            marginTop: 20,
            paddingTop: 18,
            borderTop: "1px solid #EEF1F3",
          }}
        >
          <div style={{ color: "#6B7280", marginBottom: 12 }}>
            Loaded profile : {loadedLinkedInProfiles.length}
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {loadedLinkedInProfiles.map((profile) => (
              <div
                key={`loaded-${profile.link}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#FFFFFF",
                  borderRadius: 12,
                  padding: 16,
                  border: "1px solid #EEF1F3",
                  boxShadow: "0 6px 18px rgba(23,43,77,0.03)",
                }}
              >
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <h4
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: "#172B4D",
                        margin: 0,
                      }}
                    >
                      {profile.name}
                    </h4>
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        background: "#E8EEFF",
                        color: "#2B6CFF",
                        padding: "4px 8px",
                        borderRadius: 12,
                        fontSize: 12,
                      }}
                    >
                      <img
                        src={linkedInIcon}
                        alt="LinkedIn"
                        style={{ width: 14, height: 14 }}
                      />
                    </div>
                  </div>

                  <a
                    href={profile.profileUrl ?? profile.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "block",
                      color: "#3D4AF5",
                      fontSize: 14,
                      marginTop: 6,
                      textDecoration: "none",
                      fontWeight: 500,
                    }}
                  >
                    {profile.title}
                  </a>

                  <p
                    style={{
                      color: "#6B7280",
                      fontSize: 13,
                      marginTop: 8,
                      lineHeight: 1.4,
                    }}
                  >
                    {profile.description}
                  </p>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,
                    marginLeft: 16,
                  }}
                >
                  <button
                    aria-label="add-profile"
                    onClick={() => {
                      updateLinkedInProfiles(null, profile);
                    }}
                    style={{
                      background: "#EDE8FF",
                      border: "none",
                      borderRadius: 999,
                      width: 36,
                      height: 36,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    <FaPlus color="#5B5AFF" />
                  </button>

                  <button
                    aria-label="remove-profile"
                    onClick={() =>
                      setLoadedLinkedInProfiles(
                        loadedLinkedInProfiles.filter(
                          (p) => p.link !== profile.link,
                        ),
                      )
                    }
                    style={{
                      background: "#FFECEC",
                      border: "none",
                      borderRadius: 999,
                      width: 36,
                      height: 36,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={closeIcon}
                      alt="Remove"
                      style={{ width: 14, height: 14 }}
                    />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Load Profiles Button */}
          <div
            style={{ display: "flex", justifyContent: "center", marginTop: 20 }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 8,
              }}
            >
              <button
                onClick={() => loadLinkedInProfile()}
                style={{
                  backgroundColor: "#FFFFFF",
                  borderRadius: "24px",
                  padding: "8px 20px",
                  border: "1px solid #E5E7EB",
                  cursor: "pointer",
                  color: "#5B5AFF",
                  fontWeight: 600,
                }}
              >
                <img
                  src={refreshIcon}
                  alt="Refresh"
                  style={{ width: 18, height: 18 }}
                />{" "}
                Load Profiles
              </button>
            </div>
          </div>
        </div>
      </div>
    ),
    Contact: (
      <div style={{ background: "#FFFFFF", borderRadius: "16px" }}>
        {/* Header Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div
            style={{ fontSize: "18px", fontWeight: "700", color: "#172B4D" }}
          >
            Contacts - {leadContactList.length}
          </div>

          <button
            onClick={() => setShowCreateContact(true)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: "#FFFFFF",
              borderRadius: "40px",
              padding: "8px 18px",
              border: "1px solid #EBEBEB",
              cursor: "pointer",
              fontSize: "14px",
              height: "32px",
              color: "#3D4AF5",
              fontWeight: "600",
            }}
          >
            <FaPlus size={12} color="#3D4AF5" /> Add
          </button>
        </div>

        {/* Table */}
        <table
          style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: "0",
            border: "1px solid #E5E8EB",
            borderRadius: "12px",
          }}
        >
          <thead>
            <tr>
              {["Name", "Email", "Mobile", "Company Name"].map((header) => (
                <th
                  key={header}
                  style={{
                    textAlign: "left",
                    padding: "12px 16px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#172B4D",
                    borderBottom: "1px solid #E5E8EB",
                    borderRight: "1px solid #E5E8EB",
                  }}
                >
                  {header}
                </th>
              ))}
              {hasDeletePermission && (
                <th
                  style={{
                    textAlign: "left",
                    padding: "12px 16px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#172B4D",
                    borderBottom: "1px solid #E5E8EB",
                    width: "60px",
                  }}
                >
                  Action
                </th>
              )}
            </tr>
          </thead>

          <tbody>
            {leadContactList.map((c, index) => (
              <tr
                key={index}
                style={{
                  borderBottom: "1px solid #E5E8EB",
                  cursor: "pointer",
                  transition: "0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#F9FAFF")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                <td
                  style={{
                    padding: "12px 16px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#3D4AF5",
                  }}
                >
                  {c.name}
                </td>
                <td
                  style={{
                    padding: "12px 16px",
                    fontSize: "14px",
                    color: "#172B4D",
                  }}
                >
                  {c.email}
                </td>
                <td
                  style={{
                    padding: "12px 16px",
                    fontSize: "14px",
                    color: "#172B4D",
                  }}
                >
                  {c.phone}
                </td>
                <td
                  style={{
                    padding: "12px 16px",
                    fontSize: "14px",
                    color: "#172B4D",
                  }}
                >
                  {c.company_name}
                </td>
                {hasDeletePermission && (
                  <td style={{ padding: "12px 16px" }}>
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteContact(c.id);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "0.6px solid #E5E5E5",
                        cursor: "pointer",
                        justifyContent: "center",
                        width: "32px",
                        height: "32px",
                        borderRadius: "100px",
                        background: "#FFFFFF",
                      }}
                      title="Delete Contact"
                    >
                      <ContactDeleteIcon />
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ),
    Notes: (
      <div style={{ width: "100%" }}>
        <h3 className={styles.heading}>Notes</h3>
        <div
          ref={scrollRef}
          style={{
            maxHeight: "300px",
            overflowY: "auto",
            position: "relative",
            marginTop: "25px",
          }}
        >
          {notes.notes.map((noteItem, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "25px",
              }}
            >
              <img
                src={noteItem.image || Notesprofile}
                alt="Icon"
                style={{
                  height: "40px",
                  width: "40px",
                  borderRadius: "100px",
                  marginRight: "10px",
                  flexShrink: 0,
                }}
              />
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <p className={styles.para} style={{ margin: 0 }}>
                  {noteItem.note}
                </p>
                <p
                  className={styles.foot}
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#5E6C84",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span style={{ color: "#172B4D" }}>Lead</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <img
                      src={Clock}
                      alt="date"
                      style={{ height: "18px", width: "18px" }}
                    />
                    {noteItem.date}
                  </span>
                  <span>By {noteItem.first_name}</span>
                </p>
              </div>
              <hr style={{ color: "#EBEBEB", height: "2px" }} />
            </div>
          ))}
          {/* {isLoading && (
            <div style={{ textAlign: "center", padding: "10px" }}>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <span style={{ marginLeft: "8px" }}>Loading more notes...</span>
            </div>
          )} */}
          {!hasMore && !isLoading && (
            <p style={{ textAlign: "center" }}>No more notes.</p>
          )}
        </div>
        <div className={styles.addNoteApiSection}>
          <input
            type="text"
            placeholder="Add a note..."
            className={styles.noteInput}
            value={newNote}
            onChange={(e) => setNewNote(e.target.value)}
          />

          <button
            className={styles.addNoteApiButton}
            onClick={tabLoading["Notes Add"] ? null : handleAddNote}
            disabled={tabLoading["Notes Add"]}
            style={{
              fontWeight: "500",
              fontSize: "16px",
              color: "#ffffff",
              height: "40px",
              borderRadius: "100px",
              backgroundColor: tabLoading["Notes Add"] ? "#7E8AFF" : "#3d4af5",
              padding: "10px 28px",
              lineHeight: "100%",
              border: "none",
              cursor: tabLoading["Notes Add"] ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            {tabLoading["Notes Add"] && (
              <Spinner animation="border" size="sm" />
            )}
            <span>{tabLoading["Notes Add"] ? "Adding..." : "Add"}</span>
          </button>
        </div>
        {validationError && <p className="error-text">{validationError}</p>}
        {error && <p>Error: {error}</p>}
      </div>
    ),
    Attachments: (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <style>{`
        .attachment-table { width: 100% !important; border-collapse: separate; }
        .attachment-table th, .attachment-table td { vertical-align: middle !important; padding: 12px 16px !important; }
        .attachment-table td { background: #fff; }
        .attachment-download-btn {
          background: #F4F5F7;
          border: 1px solid #E5E8EB;
          border-radius: 50%;
          width: 32px;
          height: 32px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .attachment-download-btn:hover {
          background: #EBECF0;
          border-color: #C1C7D0;
        }
        `}</style>
        <div className="d-flex justify-content-between align-items-center my-3">
          <h3 className={styles.heading}>Attachments</h3>
          <button
            onClick={tabLoading["Attachments Add"] ? null : handleAddAttachment}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: "#FFFFFF",
              borderRadius: "40px",
              padding: "8px 18px",
              border: "1px solid #EBEBEB",
              cursor: "pointer",
              fontSize: "14px",
              height: "32px",
              color: "#3D4AF5",
              fontWeight: "600",
            }}
          >
            <FaPlus size={12} color="#3D4AF5" /> Add attach{" "}
            {tabLoading["Attachments Add"] ? (
              <Spinner animation="border" size="sm" />
            ) : (
              ""
            )}
          </button>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            accept="image/*,.jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf"
            onChange={handleFileChange}
          />
        </div>
        <div className="" style={{ flex: 1 }}>
          <table className={`attachment-table ${styles.customTable}`}>
            <thead className="table-light">
              <tr>
                <th style={{ textAlign: "left" }}>File Name</th>
                <th style={{ textAlign: "left" }}>Attached By</th>
                <th style={{ textAlign: "left" }}>Date Added</th>
                <th style={{ textAlign: "left" }}>Size</th>
                <th style={{ textAlign: "center", width: "80px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {attachments?.attachments?.map((attachItem, index) => (
                <tr key={index} className="align-middle attachment-row">
                  <td>
                    <div className="d-flex gap-2 align-items-center">
                      {getIconForExtension(attachItem.file_name)}
                      <span
                        title={attachItem.file_name}
                        style={{
                          maxWidth: "200px",
                          color: "#3D4AF5",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          fontWeight: "500",
                        }}
                      >
                        {attachItem.file_name}
                      </span>
                    </div>
                  </td>
                  <td>{attachItem.first_name}</td>
                  <td>{attachItem.date}</td>
                  <td>{attachItem.file_size} MB</td>
                  <td style={{ textAlign: "center" }}>
                    <button
                      onClick={async () => {
                        const success = await downloadBlobFile(
                          attachItem.file_path,
                          attachItem.file_name,
                        );
                        if (!success) {
                          setSnackbarMessage(
                            "Download failed. Please try again.",
                          );
                          setSnackbarStatus(false);
                          handleSnackbarShow();
                        }
                      }}
                      className="attachment-download-btn"
                      title="Download"
                    >
                      <img src={Download} alt="Download" style={{ width: "16px", height: "16px" }} />
                    </button>
                  </td>
                </tr>
              ))}
              {(!attachments?.attachments || attachments.attachments.length === 0) && !isLoading && (
                <tr>
                  <td colSpan="5" className="text-center py-4" style={{ color: "#6B778C" }}>
                    No attachments found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    ),
    Activities: (
      <div style={{ width: "100%" }}>
        {/* Header with Add Button */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "16px",
          }}
        >
          <div
            style={{ fontSize: "18px", fontWeight: "700", color: "#172B4D" }}
          >
            Activities
          </div>
          <div style={{ position: "relative" }} ref={dropdownRef}>
            {/* Button */}
            <button
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "#ffffff",
                borderRadius: "40px",
                padding: "6px 14px",
                border: "1px solid #E5E7EB",
                cursor: "pointer",
                fontSize: "14px",
                color: "#3D4AF5",
                fontWeight: "600",
              }}
              onClick={() => setOpen(!open)}
            >
              <FaPlus size={12} color="#3D4AF5" /> Add <DownArrowIc />
            </button>

            {/* Dropdown Menu */}
            {open && (
              <div
                style={{
                  position: "absolute",
                  top: "44px",
                  right: 0,
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  border: "1px solid #E5E7EB",
                  boxShadow: "0px 4px 15px rgba(0,0,0,0.05)",
                  minWidth: "150px",
                  zIndex: 10,
                  padding: "6px 0",
                }}
              >
                <div
                  style={{
                    padding: "10px 14px",
                    fontSize: "14px",
                    cursor: "pointer",
                    color: "#172B4D",
                  }}
                  onClick={() => {
                    setShowCreateCall(true);
                    setOpen(false);
                  }}
                  onMouseEnter={(e) => (e.target.style.background = "#F5F6FF")}
                  onMouseLeave={(e) =>
                    (e.target.style.background = "transparent")
                  }
                >
                  Call
                </div>

                {/* <div
                  style={{
                    padding: "10px 14px",
                    fontSize: "14px",
                    cursor: "pointer",
                    color: "#172B4D",
                  }}
                  onClick={() => {
                    setOpen(false);
                    setEmailID(null);

                    setTimeout(() => setEmailID(id), 0);

                    // Email action triggered
                  }}
                  onMouseEnter={(e) => (e.target.style.background = "#F5F6FF")}
                  onMouseLeave={(e) => (e.target.style.background = "transparent")}
                >
                  Send Mail
                </div> */}
              </div>
            )}
          </div>
        </div>

        {/* Filters Row */}
        <div style={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
          {filters.map((f) => (
            <div
              key={f}
              onClick={() => setFilter(f)}
              style={{
                padding: "6px 16px",
                borderRadius: "8px",
                backgroundColor: filter === f ? "#3D4AF5" : "#F3F3F3",
                fontWeight: "500",
                fontSize: "13px",
                color: filter === f ? "#ffffff" : "#172B4D",
                cursor: "pointer",
              }}
            >
              {f}
            </div>
          ))}
        </div>

        {/* EMAIL CARD */}
        {/* <div
          style={{
            background: "#FFFFFF",
            borderRadius: "16px",
            padding: "18px",
            marginBottom: "12px",
            border: "1px solid #EBEBEB",
            cursor: "pointer",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "10px" }}>
            <div style={{ fontSize: "12px", color: "#8790A1" }}>Today , 05:30 PM</div>

            <div
              style={{
                width: "6px",
                height: "6px",
                backgroundColor: "#D9D9D9",
                borderRadius: "50%",
              }}
            ></div>

            <div style={{ fontSize: "12px", fontWeight: "600", color: "#172B4D", display: "flex", alignItems: "center", gap: "4px" }}>
              <SentIc />
              <span >Sent</span>
            </div>

          </div>

          <div style={{ display: "flex", gap: "14px", alignItems: "center" }}>
            <div
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "50%",
                backgroundColor: "#F6FAFF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src="/logo.png" alt="icon" width={28} />
            </div>

            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <div style={{ fontWeight: "600", fontSize: "15px", color: "#172B4D" }}>
                Welcome Lentera Technologies 🎉
              </div>

              <div
                style={{
                  fontSize: "13px",
                  color: "#8790A1",
                  marginTop: "4px",
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                lenteratechnologies@gmail.com • From <span style={{ color: "#3D4AF5" }}>hr@lentera.in</span>
              </div>
            </div>
          </div>
        </div> */}

        {/* CALL CARD */}
        {(activitiesList ?? []).map((activity, index) => (
          <div
            key={activity.id || index}
            style={{
              background: "#FFFFFF",
              borderRadius: "16px",
              padding: "18px",
              marginBottom: "12px",
              border: "1px solid #EBEBEB",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                style={{
                  fontWeight: "600",
                  fontSize: "15px",
                  color: "#3D4AF5",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "80%",
                }}
              >
                {activity.tag1} with {activity.tag2}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "13px",
                marginTop: "10px",
                color: "#172B4D",
              }}
            >
              <ClockIc />
              <span>{activity.date}</span>
            </div>

            <div
              style={{
                fontSize: "13px",
                color: "#8790A1",
                marginTop: "4px",
              }}
            >
              {activity.description ?? "-"}
            </div>
          </div>
        ))}
      </div>
    ),
    Quotations: (
      <div style={{ background: "#FFFFFF", borderRadius: "16px" }}>
        {/* Header Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div
            style={{ fontSize: "16px", fontWeight: "600", color: "#172B4D" }}
          >
            Quotations - 23
          </div>

          <button
            onClick={() => {
              navigate("/quotation/create", {
                state: {
                  callFrom: "Lead",
                  moduleDetail: {
                    value: id,
                    label: `${overviewData.lead_code}-${overviewData.lead_name}`,
                  },
                },
              });
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: "#ffffff",
              borderRadius: "40px",
              padding: "6px 16px",
              border: "1px solid #E5E7EB",
              cursor: "pointer",
              fontSize: "14px",
              color: "#3D4AF5",
              fontWeight: "600",
            }}
          >
            <FaPlus size={12} color="#3D4AF5" /> Add
          </button>
        </div>

        {/* Table */}
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            border: "1px solid #E5E8EB",
            borderRadius: "12px",
          }}
        >
          <thead>
            <tr>
              {[
                "Quotation No.",
                "Customer",
                "Contact Person",
                "Validity Date",
              ].map((header) => (
                <th
                  key={header}
                  style={{
                    textAlign: "left",
                    padding: "12px 16px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#172B4D",
                    borderBottom: "1px solid #E5E8EB",
                    borderRight: "1px solid #E5E8EB",
                  }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {Array.from({ length: 8 }).map((_, index) => (
              <tr
                key={index}
                style={{
                  borderBottom: "1px solid #E5E8EB",
                  transition: "0.2s",
                  cursor: "pointer",
                  height: "40px",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#F9FAFF")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                <td
                  style={{
                    padding: "6px 12px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#3D4AF5",
                  }}
                >
                  QD345345345
                </td>

                <td
                  style={{
                    padding: "6px 12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  {/* {_?.image ? (
                    <img
                      src={_.image}
                      alt={_.name}
                      style={{ width: "18px", height: "18px", borderRadius: "50%" }}
                      onError={(e) => (e.currentTarget.style.display = "none")}
                    />
                  ) : (
                    <div
                      style={{
                        width: "18px",
                        height: "18px",
                        borderRadius: "50%",
                        backgroundColor: "#E2E8F0",
                        color: "#172B4D",
                        fontSize: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        textTransform: "uppercase",
                      }}
                    >
                      {_?.name?.charAt(0)}
                    </div>
                  )} */}

                  <span style={{ fontSize: "14px", color: "#172B4D" }}>
                    Sfere
                  </span>
                </td>

                <td
                  style={{
                    padding: "6px 12px",
                    fontSize: "14px",
                    color: "#172B4D",
                  }}
                >
                  Madan Kumar B
                </td>

                <td
                  style={{
                    padding: "6px 12px",
                    fontSize: "14px",
                    color: "#172B4D",
                  }}
                >
                  16 May 2025
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ),
    History: (() => {
      let formattedDate = "";
      if (histories?.histories?.length > 0 && histories.histories[0].date) {
        const dateObj = new Date(histories.histories[0].date);
        formattedDate = dateObj.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      }
      return (
        <div>
          <h5 className="fw-semibold mb-1">History</h5>
          <div className=" py-4" style={{ overflowX: "auto" }}>
            <div style={{ overflowX: "auto" }}>
              <div style={{ minWidth: "300px" }}>
                <div className="position-relative text-center mb-4">
                  <hr />
                  <span
                    className="position-absolute top-50  start-50 translate-middle bg-white px-4 py-1 text-muted small border rounded-pill"
                    style={{ fontWeight: 500, fontSize: "15px" }}
                  >
                    {formattedDate}
                  </span>
                </div>
                {histories?.histories?.map((HistoryItem, index) => {
                  const iconKey = getCleanType(HistoryItem.type);
                  const Icon = historyIcons[iconKey] || historyIcons["note"]; // fallback icon

                  return (
                    <div key={index} className="d-flex align-items-start">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "start",
                          marginRight: "1rem",
                          position: "relative",
                        }}
                      >
                        <div
                          className="small text-muted mb-1"
                          style={{ marginRight: "1rem" }}
                        >
                          {HistoryItem.time}
                        </div>

                        <div
                          style={{
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #dee2e6",
                              borderRadius: "50%",
                              width: "30px",
                              height: "30px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: 1,
                            }}
                          >
                            {Icon}
                          </div>

                          {index !== histories?.histories?.length - 1 && (
                            <div
                              style={{
                                width: "2px",
                                height: "100px",
                                border: "1px dashed #D3D8E0",
                              }}
                            />
                          )}
                        </div>
                      </div>

                      <div style={{ flex: 1 }}>
                        <p className="mb-1">
                          <strong
                            style={{
                              fontWeight: 500,
                              fontSize: "16px",
                              color: "#21272C",
                            }}
                          >
                            {HistoryItem.type}
                          </strong>
                          {HistoryItem.link ? (
                            <span style={{ color: "#3D4AF5" }}>
                              -{HistoryItem.link}
                            </span>
                          ) : (
                            <span style={{ whiteSpace: "pre-wrap" }}>
                              {" "}
                              - {HistoryItem.description}
                            </span>
                          )}
                        </p>
                        <div className="small text-muted">
                          By {HistoryItem.first_name} on {HistoryItem.date}
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* isLoading && (
                  <div style={{ textAlign: "center", padding: "10px" }}>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span style={{ marginLeft: "8px" }}>
                      Loading more history...
                    </span>
                  </div>
                )} */}

                {!hasMore && !isLoading && (
                  <p style={{ textAlign: "center" }}>No more history.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    })(),

    Historys: (
      <div
        style={{
          background: "#FFFFFF",
          borderRadius: "16px",
          padding: "20px 24px",
          border: "1px solid #E5E8EB",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <div
            style={{
              display: "inline-block",
              padding: "4px 16px",
              backgroundColor: "#F1F4FF",
              borderRadius: "50px",
              fontWeight: "600",
              fontSize: "13px",
              color: "#172B4D",
            }}
          >
            May 23, 2025
          </div>
        </div>

        <div style={{ position: "relative", paddingLeft: "40px" }}>
          {/* Vertical Dotted Line */}
          <div
            style={{
              position: "absolute",
              left: "18px",
              top: 0,
              bottom: 0,
              width: "2px",
              background:
                "linear-gradient(to bottom, #DCE1EB 33%, transparent 33%)",
              backgroundSize: "4px 8px",
            }}
          />

          {historyList.map((item, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                gap: "16px",
                marginBottom: "24px",
                position: "relative",
              }}
            >
              {/* Time */}
              <div
                style={{
                  width: "70px",
                  fontSize: "12px",
                  fontWeight: "500",
                  color: "#8790A1",
                }}
              >
                {item.time}
              </div>

              {/* Icon */}
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  border: "1px solid #E5E7EB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "16px",
                }}
              >
                {activityIcons[item.type] || "❔"}
              </div>

              {/* Text Content */}
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#172B4D",
                  }}
                >
                  {item.title}
                </div>
                {item.description && (
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#697384",
                      margin: "6px 0",
                    }}
                  >
                    {item.description}
                  </div>
                )}
                <div style={{ fontSize: "12px", color: "#8790A1" }}>
                  By <span style={{ fontWeight: "600" }}>{item.by}</span> on{" "}
                  {item.date}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    ),
  };

  const loadLinkedInProfile = async () => {
    /*  if (isLoadingRef.current || !hasMoreRef.current) return; */
    /*  setIsLoading(true); */
    setLoadingForTab("LinkedIn", true);

    try {
      const response = await getLoadLinkedInProfilesApi(id);
      if (response.status === 200) {
        const newProfiles = response?.data.data ?? [];
        // Deduplicate by profileUrl / link / id when merging
        setLoadedLinkedInProfiles((prev) => {
          try {
            // build keyset from already-loaded and current LinkedIn grid to avoid duplicates
            const allExisting = [...prev, ...linkedInProfiles];
            const existingKeys = new Set(
              allExisting.map((p) => (p.link ?? "").toString()),
            );
            const filtered = newProfiles.filter((p) => {
              const key = (p.link ?? "").toString();
              return key && !existingKeys.has(key);
            });
            return filtered.length ? [...prev, ...filtered] : prev;
          } catch (err) {
            // fallback to appending if any unexpected structure
            return [...prev, ...newProfiles];
          }
        });
      }
    } catch (error) {
      setError(error.message);
    } finally {
      /* setIsLoading(false); */
      setLoadingForTab("LinkedIn", false);
    }
  };

  const getLinkedInProfile = useCallback(async () => {
    if (isLoadingRef.current || !hasMoreRef.current) return;
    setIsLoading(true);

    try {
      const response = await getLinkedInProfilesApi(id);
      if (response.status === 200) {
        const newProfiles = response?.data.data ?? [];
        setLinkedInProfiles(newProfiles);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    getLinkedInProfile();
  }, [id, getLinkedInProfile]);

  const updateLinkedInProfiles = async (removed_id, profile) => {
    if (removed_id) {
      setLinkedInProfileToDelete({ removed_id, profile });
      setShowLinkedInDeleteModal(true);
      return;
    }
    const payload = {
      removed_id: removed_id != null ? [removed_id] : [],
      details: profile != null ? [profile] : [],
    };

    var response = await updateLinkedInProfilesApi(payload, id);
    if (response.status === 200 && response.data.success === true) {
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
      getLinkedInProfile();

      if (profile?.link) {
        setLoadedLinkedInProfiles(
          loadedLinkedInProfiles.filter((p) => p.link !== profile.link)
        );
      }
    }
  };

  const handleConfirmLinkedInDelete = async () => {
    if (!linkedInProfileToDelete) return;

    const { removed_id } = linkedInProfileToDelete;

    // Validate removed_id to prevent injection
    if (
      !removed_id ||
      (typeof removed_id !== "string" && typeof removed_id !== "number")
    ) {
      setSnackbarMessage("Invalid profile ID");
      setSnackbarStatus(false);
      handleSnackbarShow();
      setShowLinkedInDeleteModal(false);
      setLinkedInProfileToDelete(null);
      return;
    }

    const payload = {
      removed_id: [removed_id],
      details: [],
    };

    try {
      const response = await updateLinkedInProfilesApi(payload, id);
      if (response?.status === 200 && response?.data?.success === true) {
        const safeMessage = sanitizeInput(
          response.data.message || "Profile removed successfully",
        );
        setSnackbarMessage(safeMessage);
        setSnackbarStatus(true);
        handleSnackbarShow();
        getLinkedInProfile();
      } else {
        setSnackbarMessage("Failed to remove profile");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (error) {
      setSnackbarMessage("An error occurred. Please try again.");
      setSnackbarStatus(false);
      handleSnackbarShow();
    }
  };

  const handleCancelLinkedInDelete = () => {
    setShowLinkedInDeleteModal(false);
    setLinkedInProfileToDelete(null);
  };

  return (
    <>
      <ComposeLeadModal
        id={emailId}
        show={showEmail}
        handleClose={() => setEmailShow(false)}
        succesError={(response) => {
          // setSnackbarMessage(response.message);
          // setSnackbarStatus(response.success);
          // handleSnackbarShow();
          // if (response.success === true) {
          //   setShow(false);
          //   fetchQuotation();
          //   fetchQuotationHistories();
          // }
        }}
      />
      <div className={`p-0 `}>
        <div className={`d-flex flex-wrap align-items-center ${styles.header}`}>
          <div className={`d-flex align-items-center ${styles.profileSection}`}>
            <svg
              className={styles.backIcon}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              onClick={() => navigate(-1)}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            <img
              src={overviewData.image || Profile}
              alt="Profile"
              className={styles.profilePic}
            />
          </div>
          <div className="ms-3 d-flex flex-column">
            <div className={styles.name}>{overviewData.lead_name}</div>
          </div>

          <div className={`ms-auto d-flex gap-2 ${styles.actions}`}>
            <div
              className="fs-14 fw-600 text-white d-flex justify-content-center align-items-center"
              style={{
                cursor: "pointer",
                width: "115px",
                height: "40px",
                borderRadius: "100px",
                border: "1px solid #D4DDE7",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setShowCreateCall(true);
              }}
            >
              <span
                style={{ fontSize: "14px", fontWeight: "500", color: "black" }}
              >
                Create Call
              </span>
            </div>
            {leadStatus === "Convert Account" || leadStatus === "Completed" || overviewData.customer_id != null ? (
              <div style={{ position: "relative", display: "inline-block" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    backgroundColor: "#F5F6F7",
                    borderRadius: "40px",
                    padding: "0 14px",
                    height: "40px",
                    border: "none",
                    fontSize: "14px",
                    color: "#172B4D",
                    fontWeight: "600",
                  }}
                >
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      backgroundColor: "#2C8C53",
                      borderRadius: "50%",
                      display: "inline-block",
                    }}
                  ></span>
                  {leadStatus}
                </div>
              </div>
            ) : (
              <div
                style={{ position: "relative", display: "inline-block" }}
                ref={dropdownNewRef}
              >
                <button
                  onClick={() => setStatusOpen(!statusOpen)}
                  disabled={isStatusUpdating}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    backgroundColor: "#F5F6F7",
                    borderRadius: "40px",
                    padding: "0 14px",
                    height: "40px",
                    border: "none",
                    cursor: isStatusUpdating ? "not-allowed" : "pointer",
                    fontSize: "14px",
                    color: "#172B4D",
                    fontWeight: "600",
                    opacity: isStatusUpdating ? 0.7 : 1,
                  }}
                >
                  {isStatusUpdating ? (
                    <Spinner
                      animation="border"
                      size="sm"
                      style={{ width: "12px", height: "12px", color: "#172B4D" }}
                    />
                  ) : (
                    <span
                      style={{
                        width: "10px",
                        height: "10px",
                        backgroundColor: "#2C8C53",
                        borderRadius: "50%",
                        display: "inline-block",
                      }}
                    ></span>
                  )}
                  {isStatusUpdating ? "Updating..." : leadStatus}
                  {!isStatusUpdating && <DownNewArrowIc size={16} color="#172B4D" />}
                </button>

                {statusOpen && (
                  <div
                    style={{
                      position: "absolute",
                      top: "45px",
                      left: 0,
                      backgroundColor: "#FFFFFF",
                      borderRadius: "14px",
                      boxShadow: "0px 4px 18px rgba(0,0,0,0.12)",
                      padding: "12px 0",
                      minWidth: "200px",
                      zIndex: 999,
                      height: "230px",
                      overflowX: "auto",
                    }}
                  >
                    {statusOptions.map((item, index) => (
                      <div
                        key={index}
                        onClick={async () => {
                          setStatusOpen(false);
                          if (item.label === "Convert Account") {
                            setIsStatusUpdating(true);
                            try {
                              const checkRes = await checkLeadConversionApi(id);
                              setConversionInfo(checkRes?.data || checkRes);
                              setIsConvertModalOpen(true);
                            } catch (err) {
                              console.error("Error checking lead conversion:", err);
                              setConversionInfo(null);
                              setIsConvertModalOpen(true);
                            } finally {
                              setIsStatusUpdating(false);
                            }
                            return;
                          }
                          setIsStatusUpdating(true);
                          try {
                            const response = await updateLeadStatusApi(
                              { lead_status: item.label },
                              id,
                            );
                            if (response?.success || response?.data?.success || response?.status === "success" || response?.message?.includes("success") || response) {
                              setStatus(item.label);
                              setSnackbarMessage("Status updated successfully");
                              setSnackbarStatus(true);
                              handleSnackbarShow();
                              setRefresh((prev) => !prev);
                            } else {
                              setSnackbarMessage("Failed to update status");
                              setSnackbarStatus(false);
                              handleSnackbarShow();
                            }
                          } catch (err) {
                            console.error("Error updating lead status:", err);
                            setSnackbarMessage("Error updating lead status");
                            setSnackbarStatus(false);
                            handleSnackbarShow();
                          } finally {
                            setIsStatusUpdating(false);
                          }
                        }}
                        style={{
                          padding: "10px 18px",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#172B4D",
                          cursor: "pointer",
                          transition: "0.2s",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#F6F7FF")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor = "transparent")
                        }
                      >
                        {item.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            {hasEditPermission && (
              <div
                className="fs-14 fw-600 text-white d-flex justify-content-center align-items-center"
                style={{
                  cursor: "pointer",
                  width: "82px",
                  height: "40px",
                  borderRadius: "100px",
                  border: "1px solid #D4DDE7",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/leads/create", { state: { id: id } });
                }}
                title="Edit Lead"
              >
                <span
                  style={{ fontSize: "14px", fontWeight: "500", color: "black" }}
                >
                  Edit
                </span>
              </div>
            )}
            <div
              className="fs-14 fw-600 text-white d-flex justify-content-center align-items-center"
              style={{
                cursor: "pointer",
                width: "40px",
                height: "40px",
                borderRadius: "100px",
                border: "1px solid #D4DDE7",
                textAlign: "center",
              }}
              onClick={() => setOpenThreeDot(!openThreeDot)}
            >
              <ThreeDot />
              {openThreeDot && (
                <div
                  style={{
                    position: "absolute",
                    top: "130px",
                    right: 43,
                    backgroundColor: "#ffffff",
                    borderRadius: "8px",
                    border: "1px solid #E5E7EB",
                    boxShadow: "0px 4px 15px rgba(0,0,0,0.05)",
                    padding: "6px 0",
                    zIndex: 10,
                    textAlign: "left",
                  }}
                >

                  <div
                    style={{
                      padding: "10px 14px",
                      fontSize: "15px",
                      cursor: "pointer",
                      color: "#172B4D",
                      fontWeight: "500",
                    }}
                    onClick={() => {
                      navigate("/quotation/create", {
                        state: {
                          callFrom: "Lead",
                          moduleDetail: {
                            value: id,
                            label: `${overviewData.lead_code}-${overviewData.lead_name}`,
                          },
                        },
                      });
                      setOpenThreeDot(false);
                    }}
                    onMouseEnter={(e) =>
                      (e.target.style.background = "#F5F6FF")
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.background = "transparent")
                    }
                  >
                    Create Quotation
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div style={{ height: "calc(100vh - 180px)" }}>
          <Row>
            <Col sm={12} lg={4} style={{ paddingRight: "0px", height: "100%" }}>
              <div
                className={`${styles.leftColumn}`}
                style={{ margin: "12px", height: "100%", borderRadius: "16px" }}
              >
                <h3 className={styles.head}>Lead information</h3>
                <div className={styles.leadInfo}>
                  <div className={styles.leadDetails}>
                    <p>
                      <img src={User} alt="User Icon" />{" "}
                      {overviewData.lead_owner_name || "-"}
                      <span>Lead owner</span>
                    </p>
                    <p>
                      <img src={User} alt="User Icon" />{" "}
                      {overviewData.lead_assignee_name || "-"}
                      <span>Lead assignee</span>
                    </p>
                    <p>
                      <img src={Mail} alt="Email Icon" />{" "}
                      {overviewData.email || "-"}
                    </p>
                    <p>
                      <img src={Phone} alt="Phone Icon" />{" "}
                      {overviewData.contact_number1 || "-"} <span>Primary</span>
                    </p>
                    <p>
                      <img src={Phone} alt="Phone Icon" />{" "}
                      {overviewData.contact_number2 || "-"}
                      <span>Secondary</span>
                    </p>
                    <p>
                      <img src={Building} alt="Company Icon" />{" "}
                      {overviewData.company_name || "-"}
                    </p>
                    <p>
                      <img src={IT} alt="Industry Icon" />{" "}
                      {overviewData.industry || "-"}
                    </p>
                    <p>
                      <img src={Location} alt="Location Icon" />{" "}
                      {overviewData.address_formatted || "-"}
                    </p>
                  </div>
                  <div style={{ marginTop: "20px", width: "100%" }}>
                    {/* Title */}
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#172B4D",
                        marginBottom: "18px",
                      }}
                    >
                      Other information
                    </div>

                    {/* Container */}
                    <div
                      style={{
                        display: "grid",
                        rowGap: "14px",
                        columnGap: "16px",
                        alignItems: "start",
                        paddingBottom: "16px",
                        borderBottom: "1px solid #E5E5E5",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between", // or "flex-start" if closer
                          gap: "12px",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#8790A1",
                          }}
                        >
                          Fax
                        </div>

                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#172B4D",
                          }}
                        >
                          {overviewData.fax || "-"}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between", // or "flex-start" if closer
                          gap: "12px",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#8790A1",
                          }}
                        >
                          Lead source
                        </div>

                        <div
                          title="Social  Marketing"
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#172B4D",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "160px", // adjust as required
                            textAlign: "right",
                          }}
                        >
                          {overviewData.lead_source || "-"}
                        </div>
                      </div>
                      {/* Employees */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between", // or "flex-start" if closer
                          gap: "12px",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#8790A1",
                          }}
                        >
                          No. of Employees
                        </div>

                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#172B4D",
                          }}
                        >
                          {overviewData.emp_count || "0"} employees
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between", // or "flex-start" if closer
                          gap: "12px",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#8790A1",
                          }}
                        >
                          Email Marketing
                        </div>

                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#172B4D",
                          }}
                        >
                          {overviewData.email_marketing ? "Yes" : "No"}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between", // or "flex-start" if closer
                          gap: "12px",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#8790A1",
                          }}
                        >
                          Annual Revenue
                        </div>

                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#172B4D",
                          }}
                        >
                          {overviewData.annual_revenue ?? "-"}
                        </div>
                      </div>
                    </div>
                  </div>

                  <h3 className={styles.head} style={{ marginTop: "12px" }}>
                    Description
                  </h3>
                  <div className={styles.lead_desc}>
                    <p>{overviewData.description || "-"}</p>
                  </div>
                  <h3 className={styles.head} style={{ marginTop: "20px" }}>
                    Created at
                  </h3>
                  <div className={styles.lead_desc}>
                    <p>{overviewData.created_time || "-"}</p>
                  </div>
                </div>
              </div>
            </Col>

            <Col sm={12} lg={8} style={{ paddingLeft: "0px", height: "100%" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "#ffffff",
                  padding: "18px",
                  marginTop: "12px",
                  marginRight: "12px",
                  marginLeft: "12px",
                  borderRadius: "16px",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    paddingBottom: "8px",
                  }}
                >
                  <div
                    className={styles.tabs}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // justifyContent: "space-between",
                      flexWrap: "nowrap", // FORCE single line
                      width: "100%",
                    }}
                  >
                    {[
                      "Overview",
                      overviewData.company_name &&
                      overviewData.company_name !== ""
                        ? "LinkedIn"
                        : null,
                      "Contact",
                      "Notes",
                      "Attachments",
                      "Activities",
                      // "Quotations",
                      "History",
                    ]
                      .filter((item) => item !== null)
                      .map((tab) => (
                        <button
                          key={tab}
                          className={`${activeTab === tab ? styles.activeTab : ""}`}
                          onClick={() => setActiveTab(tab)}
                          style={{
                            whiteSpace: "nowrap", // prevent text split
                            flexShrink: 1, // allow compress
                            padding: "4px 10px", // lighter padding to fit more
                            fontSize: "13px",
                          }}
                        >
                          {tab}
                        </button>
                      ))}
                  </div>
                </div>

                <div style={{ position: "relative", flex: 1 }}>
                  {tabLoading[activeTab] && (
                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        background: "rgba(255,255,255,0.7)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 5,
                        flexDirection: "row",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span style={{ marginLeft: "8px" }}>
                        Loading {activeTab}...
                      </span>
                    </div>
                  )}
                  {tabContent[activeTab]}
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <WebSiteSearchModal
          open={showWebSiteModal}
          website={websiteUrl}
          onEdit={() => {
            openWebsiteEditModal(true);
            openWebsiteModal(false);
          }}
          onClose={() => {
            openWebsiteModal(false);
          }}
          onDataSubmit={async (url, webScrapDetails) => {
            console.log("webScrapDetails submitted:", webScrapDetails);
            let response = await updateWebsiteInfoApi({ website: url }, id);
            if (response.success === true) {
              updateWebScraping(webScrapDetails);
            }

            setRefresh((prev) => !prev);
            openWebsiteModal(false);
          }}
        />
        <WebSiteEditModal
          open={showWebSiteEditModal}
          editUrl={overviewData.website || ""}
          onClose={() => openWebsiteEditModal(false)}
          onSubmit={(isSearch, websiteUrl) => {
            if (isSearch && websiteUrl) {
              setWebSite(websiteUrl);
              openWebsiteModal(true);
              openWebsiteEditModal(false);
            }
          }}
          url={websiteUrl}
        />
      </div>

      {isOpenDelete && (
        <WebSiteDeleteModal
          deleteUrl={`${apiUrl}web/update_lead_website/${id}`}
          payload={{ website: "" }}
          onSuccess={onSuccessDelete}
          onCancel={cancelDelete}
        />
      )}

      {showLinkedInDeleteModal && (
        <LinkedInDeleteConfirmModal
          onConfirm={handleConfirmLinkedInDelete}
          onCancel={handleCancelLinkedInDelete}
        />
      )}

      <CreateContactModal
        isOpen={showCreateContact}
        onClose={() => setShowCreateContact(false)}
        onCreated={() => {
          fetchContacts();
        }}
        notify={notify}
        linkTo={{
          type: "Lead",
          id,
          label: `${overviewData.lead_code}-${overviewData.lead_name}`,
        }}
      />

      {isOpenDeleteContact && (
        <DeleteModal
          deleteUrl={`contact/delete/${deleteContactId}`}
          onSuccess={onSuccessDeleteContact}
          onCancel={cancelDeleteContact}
        />
      )}

      <CreateCallModal
        isOpen={showCreateCall}
        onClose={() => setShowCreateCall(false)}
        notify={notify}
        linkTo={{
          type: "Lead",
          id,
          label: `${overviewData.lead_code}-${overviewData.lead_name}`,
        }}
      />

      <LeadConversionModal
        isOpen={isConvertModalOpen}
        onClose={() => setIsConvertModalOpen(false)}
        leadData={{
          id,
          lead_name: overviewData.lead_name,
          company_name: overviewData.company_name,
          first_name: overviewData.first_name,
          phone: overviewData.phone_number || overviewData.contact_number1,
          email: overviewData.email,
        }}
        conversionInfo={conversionInfo}
        onConfirm={handleConfirmConversion}
        isSubmitting={isConverting}
      />

      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default LeadDetails;
